import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import golbal from './global';
import auditions from './auditions';
import mockEventSync from './mockEventSync';

const store = new Vuex.Store({

  ...golbal,
  modules: {
    auditions,
    mockEventSync
  }
});


export {
  store
};



// WEBPACK FOOTER //
// ./src/store/index.js